export enum FormContent {
  firstName = "firstName",
  lastName = "lastName",
  company = "company",
  companyAddress = "companyAddress",
  email = "email",
  city = "city",
  country = "country",
  postalCode = "postalCode",
}
